<ion-header>
  <ion-toolbar>
    <ion-title>{{ 'Rejection reason' | locale }}</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <form [formGroup]="form" class="flex flex-col gap-3 p-4 h-full">
    <app-textarea
      [formControl]="form.controls.reason"
      [label]="'Please provide a rejection reason'"
      [errorMessage]="
        form.controls.reason.dirty ||
        form.controls.reason.touched ||
        forceShowErrors()
          ? form.controls.reason.errors?.['error']
          : null
      "
      [rows]="6"
      [maxLength]="500"
    />
    <app-button [type]="'danger'" (click)="submit()">Reject</app-button>
  </form>
</ion-content>
